import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Browser from '@wetransfer/concorde-browser';
import Cookie from '@wetransfer/concorde-cookie';

import Upsell from './upsell';

import Link from './link';

import Email from './email';

import Analytics from '@module/analytics';
import LaunchDarkly from '@module/launchdarkly';

import Actions from '@app/action';
import Helper from '@app/helper';
import {
  COOKIE_TRANSFER_TYPE_LINK,
  COOKIE_TRANSFER_TYPE_EMAIL,
} from '@constant/cookie-transfer-types';

import { EXPERIMENT_UPSELL_SURVEY } from '@constant/experiments';

const upsellKeys = ['upsell_two', 'upsell_three'];

export const getUpsellKey = () => {
  if (Browser.platform('Mac')) {
    // On first visit of Mac user always display macapp upsell (should be the last)
    if (Helper.getWTSent() === 0) {
      return 'upsell_macapp';
    }
    upsellKeys.unshift('upsell_macapp');
  }

  if (LaunchDarkly.getVariant(EXPERIMENT_UPSELL_SURVEY)) {
    upsellKeys.unshift('upsell_survey');
  }

  // randomly display an upsell if nothing has returned earlier
  return upsellKeys[Math.floor(Math.random() * upsellKeys.length)];
};

export class Complete extends React.PureComponent {
  state = {
    manualCopy: false,
    copied: false,
    shouldDisplayUpsell: false,
    upsellKey: getUpsellKey(),
  };

  componentDidMount() {
    this.rememberInCookie();
  }

  handleUpsellClick = () => {
    const { upsellKey } = this.state;

    Analytics.trackStructEvent({
      category: 'upsell',
      action: 'click_upsell_button',
      label: upsellKey,
      property: 'upload_page',
    });
  };

  // Get the current transfer type and create a new Transfer
  onNewTransfer = () => {
    Analytics.trackStructEvent({
      category: 'transfer',
      action: 'click_continue',
    });
    const { createSimilarTransfer, transfer } = this.props;
    createSimilarTransfer(transfer);
  };

  rememberInCookie() {
    const { user, transfer } = this.props;
    // Secure these cookies on non-dev environments, set expiry to 365 days
    const cookieOptions = { secure: !__DEV__, days: 365 };
    // ttype is what current users have, so we can keep using their existing preference
    // when we release the site. ttype = transfer type.
    // For compatibility reasons.. we save it as a number.
    // TODO: REMOVE after rollout, we want sane cookies!
    let transferType = transfer.type;
    if (transferType === 'link') {
      transferType = COOKIE_TRANSFER_TYPE_LINK;
    } else {
      transferType = COOKIE_TRANSFER_TYPE_EMAIL;
    }
    Cookie.set('wt_ttype', transferType, cookieOptions);

    // Remember recipients and sender email addresses
    if (transfer.type === 'email') {
      if (!user || !user.loggedIn) {
        let savedAddresses = Cookie.get('wt_to') || '';
        savedAddresses = savedAddresses.split(/\s*,\s*/);

        for (const email of transfer.recipients) {
          if (savedAddresses.indexOf(email.toLowerCase()) !== -1) {
            continue;
          }
          savedAddresses.push(email);
        }
        Cookie.set('wt_to', savedAddresses.join(','), cookieOptions);
      }

      Cookie.set('wt_from', transfer.sender, cookieOptions);
    }
  }

  displayUpsell = () => {
    const { user } = this.props;
    const { upsellKey } = this.state;

    Analytics.trackStructEvent({
      category: 'transfer',
      action: 'click_send_another',
    });

    if (user.loggedIn) {
      this.onNewTransfer();
    } else {
      this.setState({ shouldDisplayUpsell: true });

      Analytics.trackStructEvent({
        category: 'upsell',
        action: 'show_page',
        label: upsellKey,
        property: 'upload_page',
      });
    }
  };

  render() {
    const { transfer } = this.props;
    const { upsellKey, shouldDisplayUpsell } = this.state;

    let content = <Email onRequestClose={this.displayUpsell} />;

    if (shouldDisplayUpsell) {
      content = (
        <Upsell
          upsellKey={upsellKey}
          onNewTransfer={this.onNewTransfer}
          onHandleUpsellClick={this.handleUpsellClick}
        />
      );
    } else if (transfer.type === 'link') {
      content = <Link onRequestClose={this.displayUpsell} />;
    }

    return (
      <div className="transfer__window uploader uploader--complete">
        {content}
      </div>
    );
  }
}

Complete.propTypes = {
  createSimilarTransfer: PropTypes.func.isRequired,
  session: PropTypes.object,
  transfer: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  createSimilarTransfer: Actions.Transfer.createSimilar,
};

export default connect(
  null,
  mapDispatchToProps
)(Complete);
